// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"9666c0be20f85cdafe32","452":"d32ba4391374ad78e9d9","453":"a84aff72ef0994cb94e3","454":"4bf68e88337de4a8905d","551":"b43dee50344edb4699de","577":"a3cfe97717211666a8d7"}[chunkId] + ".js";
};